<template>
  <div id="app" v-on="isDropdownOpen ? { click : collapse} : null" @keydown.esc="collapse">
    <es-skip-nav/>
    <nav-bar/>
    <div class="page" :class="{ sidebarExpanded:  $store.state.sidebarOpen === true, 'not-authorized': !($store.state.user && activeModule) }">
      <side-bar @keyboard-navigate="handleKeyboardNavigation"/>
      <main role="main" style="overflow: hidden" id="main-content">
        <es-notification v-if="isOpen"/>
        <es-breadcrumbs id="breadcrumbsId" />
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import EsBreadcrumbs from '@/components/EsBreadcrumbs.vue';
import NavBar from '@/components/NavBar.vue';
import EsNotification from '@/components/EsNotification.vue';
import SideBar from '@/components/SideBar.vue';
import NotificationManager from '@/mixins/NotificationManager';
import EsSkipNav from '@/components/EsSkipNav.vue';
import RouterViewFocus from '@/mixins/RouterViewFocus';

export default {
  name: 'App',
  mixins: [NotificationManager, RouterViewFocus],
  components: {
    EsBreadcrumbs,
    EsNotification,
    NavBar,
    SideBar,
    EsSkipNav,
  },
  computed: {
    ...mapGetters({
      activeModule: 'appModules/getActiveModule',
    }),
    isDropdownOpen() {
      return this.$store.state.profileDropDownOpen;
    },
  },
  methods: {
    ...mapActions([
      'collapseProfileDropDown',
    ]),
    collapse(event) {
      if (!this.isDropdownOpen) {
        return;
      }
      const dropdowns = document.querySelectorAll('#profile-dropdown');
      const dropdownEl = dropdowns[0];
      if (dropdownEl && !dropdownEl.contains(event.target)) {
        this.collapseProfileDropDown();
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  main
    @media (max-width: 768px)
      padding-left: 0px !important
    width: 100%
  .page:not(.not-authorized)
    display: grid
    grid-template-columns: 54px 1fr
    height: 100%
    width: 100%
    padding-top: calc(2.9rem + 80px)
    &.sidebarExpanded
      grid-template-columns: 145px 1fr
</style>
